import { isEmpty } from 'ramda';
import { ANALYTICS_SCHEMA_URLS } from '../constants/analytics';
import { PRODUCT_NAMES_MAP } from '../constants/productTypes';

export function getAnalyticEventIndex(index) {
  if (typeof index === 'number' && !isNaN(index)) {
    return index;
  } else if (typeof index === 'string' && index && !isNaN(Number(index))) {
    return Number(index);
  }

  return null;
}

export function buildMainEvent({
  schema,
  game_id = '',
  bonus_id = '',
  wagering_id = '',
  message = '',
}) {
  return {
    schema,
    data: {
      game_id,
      bonus_id,
      wagering_id,
      message,
    },
  };
}

export function buildContextParamsEvent({
  provider_id = '',
  position_index = null,
  section_index = null,
  product_type,
}) {
  return {
    schema: ANALYTICS_SCHEMA_URLS.CONTEXT_CASINO_PARAMETERS,
    data: {
      product_type:
        PRODUCT_NAMES_MAP[product_type] || product_type || 'live_casino',
      provider_id,
      position_index: getAnalyticEventIndex(position_index),
      section_index: getAnalyticEventIndex(section_index),
    },
  };
}

export function buildLocationContextEvent({
  screen_name = '',
  screen_area = '',
  screen_area_detail = '',
  event_detail = '',
}) {
  return {
    schema: ANALYTICS_SCHEMA_URLS.CONTEXT_EVENT_LOCATION,
    data: {
      screen_name,
      screen_area,
      screen_area_detail,
      event_detail,
    },
  };
}

export function buildAnalyticsEvents({
  schema,
  game_id,
  bonus_id,
  wagering_id,
  message,
  //
  section_index,
  position_index,
  provider_id,
  //
  screen_name = '',
  screen_area = '',
  screen_area_detail = '',
  event_detail = '',

  product_type,
}) {
  return {
    event: buildMainEvent({
      schema,
      game_id,
      bonus_id,
      wagering_id,
      message,
    }),
    contexts: [
      buildLocationContextEvent({
        screen_name,
        screen_area,
        screen_area_detail,
        event_detail,
      }),
      buildContextParamsEvent({
        section_index,
        position_index,
        provider_id,
        product_type,
      }),
    ],
  };
}

export function getCurrentMonthIndex() {
  const date = new Date();
  const month = date.getMonth();
  return month.toString();
}

export function getPrevMonthIndex() {
  const currentMonthIndex = getCurrentMonthIndex();
  let prevMonthIndex = currentMonthIndex - 1;
  if (prevMonthIndex < 0) {
    prevMonthIndex = 11;
  }

  return prevMonthIndex.toString();
}

export function buildGrowthbookContext(params) {
  return {
    schema: 'iglu:com.psp/growthbook_context/jsonschema/1-0-0',
    data: {
      experiment_key: params?.experiment?.key,
      experiment_variant_id: Number(params?.result?.variationId),
    },
  };
}

export function addContextToAnalytics(analytics, contextList) {
  if (
    !analytics?.addGlobalContext ||
    isEmpty(contextList) ||
    !contextList ||
    !Array.isArray(contextList)
  ) {
    return null;
  }

  analytics.addGlobalContext(() => {
    try {
      return contextList;
    } catch (e) {
      return [];
    }
  });
}
